import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpPut, httpGet, httpDelete, httpPatch } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { bgPath, bgVendorReportPath, bgVendorEditPath, homePath } from 'routes'

const GET_BANK_GUARANTEE = makeKeys('GET_BANK_GUARANTEE')
const CREATE_BANK_GUARANTEE = makeKeys('CREATE_BANK_GUARANTEE')
const UPLOAD_BG_ATTACHMENTS = makeKeys('UPLOAD_BG_ATTACHMENTS')
const SUBMIT_BANK_GUARANTEE = makeKeys('SUBMIT_BANK_GUARANTEE')
const GET_BANK_GUARANTEE_DETAIL = makeKeys('GET_BANK_GUARANTEE_DETAIL')
const UPDATE_BANK_GUARANTEE = makeKeys('UPDATE_BANK_GUARANTEE')
const PATCH_DATA_BANK_GUARANTEE = makeKeys('PATCH_DATA_BANK_GUARANTEE')
const DELETE_BANK_GUARANTEE = makeKeys('DELETE_BANK_GUARANTEE')
const CANCEL_BANK_GUARANTEE = makeKeys('CANCEL_BANK_GUARANTEE')
const ACTION_BANK_GUARANTEE = makeKeys('ACTION_BANK_GUARANTEE')
const LOAD_BG_FOR_EXTEND = makeKeys('LOAD_BG_FOR_EXTEND')
const GET_REF_BG_OPTIONS = makeKeys('GET_REF_BG_OPTIONS')
const GET_JOB = makeKeys('GET_JOB')
const GET_BANK_OWNER = makeKeys('GET_BANK_OWNER')
const GET_COMPANY_OPTIONS = makeKeys('BG_GET_COMPANY_OPTIONS')
const GET_VENDOR_OPTIONS = makeKeys('BG_GET_VENDOR_OPTIONS')
const GET_VENDOR_CONTACTS = makeKeys('GET_VENDOR_CONTACTS')
const GET_BG_WORKFLOW = makeKeys('GET_BG_WORKFLOW')
const CLEAR_BG_FROM_DATA = 'CLEAR_BG_FROM_DATA'
const GET_FINANCE_USERS = makeKeys('GET_FINANCE_USERS')
const EXPORT_BG_DATA = makeKeys('EXPORT_BG_DATA')

export const getBankGuarantees = makeAction(GET_BANK_GUARANTEE.REQUEST, 'query')
export const createBankGuarantee = makeAction(CREATE_BANK_GUARANTEE.REQUEST, 'data', 'isSubmit', 'history')
export const uploadAttachments = makeAction(UPLOAD_BG_ATTACHMENTS.REQUEST, 'id', 'data', 'isSubmit','history', 'actionKey', 'onUpdateSuccess')
export const submitBankGuarantee = makeAction(SUBMIT_BANK_GUARANTEE.REQUEST, 'id', 'history')
export const getBankGuaranteeDetail = makeAction(GET_BANK_GUARANTEE_DETAIL.REQUEST, 'id')
export const updateBankGuarantee = makeAction(UPDATE_BANK_GUARANTEE.REQUEST, 'data', 'isSubmit', 'history', 'actionKey')
export const patchDataBankGuarantee = makeAction(PATCH_DATA_BANK_GUARANTEE.REQUEST, 'data', 'onUpdateSuccess')
export const deleteBankGuarantee = makeAction(DELETE_BANK_GUARANTEE.REQUEST, 'id', 'history')
export const cancelBankGuarantee = makeAction(CANCEL_BANK_GUARANTEE.REQUEST, 'id', 'comment', 'history')
export const actionBankGuarantee = makeAction(ACTION_BANK_GUARANTEE.REQUEST, 'data', 'history')
export const loadBankGuaranteeForExtend = makeAction(LOAD_BG_FOR_EXTEND.REQUEST, 'id', 'onLoadDataSuccess')
export const getRefBankGuaranteeOptions = makeAction(GET_REF_BG_OPTIONS.REQUEST)
export const getJobs = makeAction(GET_JOB.REQUEST)
export const getBankOwners = makeAction(GET_BANK_OWNER.REQUEST)
export const getCompanyOptions = makeAction(GET_COMPANY_OPTIONS.REQUEST)
export const getVendorOptions = makeAction(GET_VENDOR_OPTIONS.REQUEST)
export const getVendorContacts = makeAction(GET_VENDOR_CONTACTS.REQUEST, 'vendorCode', 'companyCode', 'onGetDataSuccess')
export const getWorkflow = makeAction(GET_BG_WORKFLOW.REQUEST, 'id')
export const clearFormData = makeAction(CLEAR_BG_FROM_DATA)
export const getFinanceUser = makeAction(GET_FINANCE_USERS.REQUEST)
export const exportBGData = makeAction(EXPORT_BG_DATA.REQUEST, 'query', 'onSuccess')

const getBankGuaranteesSuccess = makeAction(GET_BANK_GUARANTEE.SUCCESS, 'data')
const getBankGuaranteesFailure = makeAction(GET_BANK_GUARANTEE.FAILURE)
const getBankGuaranteeDetailSuccess = makeAction(GET_BANK_GUARANTEE_DETAIL.SUCCESS, 'data')
const getRefBankGuaranteeOptionsSuccess = makeAction(GET_REF_BG_OPTIONS.SUCCESS, 'data')
const getJobsSuccess = makeAction(GET_JOB.SUCCESS, 'data')
const getBankOwnersSuccess = makeAction(GET_BANK_OWNER.SUCCESS, 'data')
const getCompanyOptionsSuccess = makeAction(GET_COMPANY_OPTIONS.SUCCESS, 'data')
const getVendorOptionsSuccess = makeAction(GET_VENDOR_OPTIONS.SUCCESS, 'data')
const getWorkflowSuccess = makeAction(GET_BG_WORKFLOW.SUCCESS, 'data')
const getFinanceUserSuccess = makeAction(GET_FINANCE_USERS.SUCCESS, 'data')
const exportBGDataSuccess = makeAction(EXPORT_BG_DATA.SUCCESS, 'data')
const exportBGDataFailure = makeAction(EXPORT_BG_DATA.FAILURE)

const apiPath = path => path ? urlWithPrefix(`bankGuarantees/${path}`) : urlWithPrefix('bankGuarantees')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* getBankGuaranteesRequest(action) {
  const { query } = action.payload

  try {
    yield put(appLoading('Loading Bank Guarantee Data'))
    const response = yield httpGet(apiPath(), { ...query })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBankGuaranteesSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Bank Guarantee Error!'))
    }
    yield put(getBankGuaranteesFailure())
    yield put(appLoaded())
  }
}

function* createBankGuaranteeRequest(action) {
  const { data, isSubmit, history } = action.payload

  try {
    yield put(appLoading('Creating bank guarantee.'))
    const response = yield httpPost(apiPath(), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      const { id } = response.data
      var attachmentsData = {}
      if (data.BG01) attachmentsData.BG01 = data.BG01
      if (data.BG02) attachmentsData.BG02 = data.BG02

      if (Object.keys(attachmentsData).length) {
        yield put(uploadAttachments(id, attachmentsData, isSubmit, history))
      } else {
        if (isSubmit) {
          yield put(submitBankGuarantee(id, history))
        } else {
          yield put(toastSuccess('Create bank guarantee success.'))
          history.push(bgVendorReportPath)
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create bank guarantee error!'))
    }
  }
}

function* uploadAttachmentsRequest(action) {
  const { id, data, isSubmit, history, actionKey, onUpdateSuccess } = action.payload

  try {
    yield put(appLoading(`Upload attachments.`))
    const response = yield httpPost(apiPath(`${id}/attachments`), data, multipartHeader /*, config */)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (isSubmit) {
          yield put(submitBankGuarantee(id, history))
        } else {
          if (actionKey) {
            const submitData = { 
              id: data.id, 
              comment: data.comment, 
              attachment: data.commentAttachment, 
              sn: data.sn,
              action: actionKey
            }

            yield put(actionBankGuarantee(submitData, history))
          } else {
            yield put(toastSuccess('Save bank guarantee success.'))
            yield put(appLoaded())
            if (onUpdateSuccess) {
              onUpdateSuccess()
            }
            if (history) {
              history.push(bgVendorReportPath)
            }
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Upload attachments data fail.'))
  }
}

function* getBankGuaranteeDetailRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Loading bank guarantee data'))
    const response = yield httpGet(apiPath(id))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBankGuaranteeDetailSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load bank guarantee data error!'))
    }
    yield put(appLoaded())
  }
}

function* updateBankGuaranteeRequest(action) {
  const { data, isSubmit, history, actionKey = '' } = action.payload

  try {
    yield put(appLoading('Updating bank guarantee data.'))
    const response = yield httpPut(apiPath(data.id), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      var attachmentsData = {}
      if (data.BG01) attachmentsData.BG01 = data.BG01
      if (data.BG02) attachmentsData.BG02 = data.BG02

      if (Object.keys(attachmentsData).length) {
        yield put(uploadAttachments(data.id, attachmentsData, isSubmit, history, actionKey))
      } else {
        if (isSubmit) {
          yield put(submitBankGuarantee(data.id, history))
        } else {
          if (actionKey) {
            const submitData = { 
              id: data.id, 
              comment: data.comment, 
              attachment: data.commentAttachment, 
              sn: data.sn,
              action: actionKey
            }

            yield put(actionBankGuarantee(submitData, history))
          } else {
            yield put(toastSuccess('Update bank guarantee success.'))
            history.push(bgVendorReportPath)
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update bank guarantee error!'))
    }
  }
}

function* patchDataBankGuaranteeRequest(action) {
  const { data, onUpdateSuccess } = action.payload

  try {
    yield put(appLoading('Updating bank guarantee data.'))
    const response = yield httpPatch(apiPath(data.id), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      var attachmentsData = {}
      if (data.BG01) attachmentsData.BG01 = data.BG01
      if (data.BG02) attachmentsData.BG02 = data.BG02

      if (Object.keys(attachmentsData).length) {
        yield put(uploadAttachments(data.id, attachmentsData, false, null, '', onUpdateSuccess))
      } else {
        yield put(toastSuccess('Save bank guarantee success.'))
        if (onUpdateSuccess) {
          onUpdateSuccess()
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update bank guarantee error!'))
    }
  }
}

function* submitBankGuaranteeRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading('Submit bank guarantee data.'))
    const response = yield httpPut(apiPath(`${id}/submit`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        history.push(bgVendorReportPath)
        yield put(toastSuccess('Submit bank guarantee data success.'))
      } else {
        yield put(toastError('Submit bank guarantee data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    history.push(bgVendorEditPath(id))
    yield put(toastError(e.data.message))
  }
}

function* deleteBankGuaranteeRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading('Delete bank guarantee data.'))
    const response = yield httpDelete(apiPath(`${id}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess('Delete bank guarantee data success.'))
        history.push(bgVendorReportPath)
      } else {
        yield put(toastError('Delete bank guarantee data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* cancelBankGuaranteeRequest(action) {
  const { id, comment, history } = action.payload
  try {
    yield put(appLoading('Cancel bank guarantee data.'))
    const response = yield httpPut(apiPath(`${id}/cancel`), { id, comment })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess('Cancel bank guarantee data success.'))
        history.push(bgVendorReportPath)
      } else {
        yield put(toastError('Cancel bank guarantee data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* loadBankGuaranteeForExtendRequest(action) {
  const { id, onLoadDataSuccess } = action.payload
  try {
    yield put(appLoading('Loading bank guarantee data for extend.'))
    const response = yield httpGet(apiPath(`${id}/dataForExtend`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onLoadDataSuccess(response.data)
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* getRefBankGuaranteeOptionsRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/bgRef'))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getRefBankGuaranteeOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getRefBankGuaranteeOptionsSuccess([]))
  }
}

function* getJobsRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/jobs'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getJobsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getJobsSuccess([]))
  }
}

function* getBankOwnersRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/bankOwners'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBankOwnersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getBankOwnersSuccess([]))
  }
}

function* getCompanyOptionsRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/company'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getCompanyOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getCompanyOptionsSuccess([]))
  }
}

function* getVendorOptionsRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/vendor'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getVendorOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getVendorOptionsSuccess([]))
  }
}

function* getVendorContactsRequest(action) {
  const { vendorCode, companyCode, onGetDataSuccess } = action.payload
  try {
    const response = yield httpGet(apiPath(`vendorContact/${vendorCode}/${companyCode}`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data && onGetDataSuccess) {
        onGetDataSuccess(response.data)
      }
    }
  } catch (e) {
  }
}

function* getWorkflowRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(apiPath('workflowApproverViewMode'), { id })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWorkflowSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getWorkflowSuccess([]))
  }
}

function* actionBankGuaranteeRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(apiPath(`${data.id}/action`), data, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      if (history.location.search.includes('h=true')) {
        history.push(homePath)
      } else {
        history.push(bgPath)
      }
      yield put(toastSuccess('Action bank guarantee success.'))
    }
  } catch (e) {
    yield put(toastError(e.data.message || 'Action bank guarantee fail.'))
    yield put(appLoaded())
  }
}

function* getFinanceUserRequest(action) {
  try {
    const response = yield httpGet('members/financeBGUsers')
    if (response.status >= 200 && response.status < 300) {
      var result = (response.data || []).map(x => ({ value: x.userName, text: x.fullName }))
      yield put(getFinanceUserSuccess(result))
    }
  } catch (e) {
  }
}

function* exportBGDataRequest(action) {
  const { query, onSuccess } = action.payload

  try {
    yield put(appLoading('Export Bank Guarantee Data'))
    const response = yield httpGet(apiPath('export'), { ...query })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(exportBGDataSuccess(response.data))
        if (onSuccess) onSuccess()
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Export Bank Guarantee Error!'))
    }
    yield put(exportBGDataFailure())
    yield put(appLoaded())
  }
}

export function* watchBankGuaranteeSaga() {
  yield takeLatest(GET_BANK_GUARANTEE.REQUEST, getBankGuaranteesRequest)
  yield takeLatest(CREATE_BANK_GUARANTEE.REQUEST, createBankGuaranteeRequest)
  yield takeLatest(UPLOAD_BG_ATTACHMENTS.REQUEST, uploadAttachmentsRequest)
  yield takeLatest(GET_BANK_GUARANTEE_DETAIL.REQUEST, getBankGuaranteeDetailRequest)
  yield takeLatest(UPDATE_BANK_GUARANTEE.REQUEST, updateBankGuaranteeRequest)
  yield takeLatest(PATCH_DATA_BANK_GUARANTEE.REQUEST, patchDataBankGuaranteeRequest)
  yield takeLatest(SUBMIT_BANK_GUARANTEE.REQUEST, submitBankGuaranteeRequest)
  yield takeLatest(DELETE_BANK_GUARANTEE.REQUEST, deleteBankGuaranteeRequest)
  yield takeLatest(CANCEL_BANK_GUARANTEE.REQUEST, cancelBankGuaranteeRequest)
  yield takeLatest(LOAD_BG_FOR_EXTEND.REQUEST, loadBankGuaranteeForExtendRequest)
  yield takeLatest(GET_REF_BG_OPTIONS.REQUEST, getRefBankGuaranteeOptionsRequest)
  yield takeLatest(GET_JOB.REQUEST, getJobsRequest)
  yield takeLatest(GET_BANK_OWNER.REQUEST, getBankOwnersRequest)
  yield takeLatest(GET_COMPANY_OPTIONS.REQUEST, getCompanyOptionsRequest)
  yield takeLatest(GET_VENDOR_OPTIONS.REQUEST, getVendorOptionsRequest)
  yield takeLatest(GET_VENDOR_CONTACTS.REQUEST, getVendorContactsRequest)
  yield takeLatest(GET_BG_WORKFLOW.REQUEST, getWorkflowRequest)
  yield takeLatest(ACTION_BANK_GUARANTEE.REQUEST, actionBankGuaranteeRequest)
  yield takeLatest(GET_FINANCE_USERS.REQUEST, getFinanceUserRequest)
  yield takeLatest(EXPORT_BG_DATA.REQUEST, exportBGDataRequest)
}

const initial = {
  listBankGuarantee: { data: {}, loading: false },
  bankGuarantee: { data: {}, loading: false },
  bgRefOptions: { data: [], loading: false, companyCode: '', vendorCode: '' },
  jobs: { data: [], loading: false },
  bankOwners: { data: [], loading: false },
  companyOptions: { data: [], loading: false },
  vendorOptions: { data: [], loading: false },
  workflow: { data: [], loading: false },
  financeUser: { data: [], loading: false },
  bgExport: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [GET_BANK_GUARANTEE.REQUEST]: () => ({
    ...state,
    listBankGuarantee: { data: {}, loading: true }
  }),
  [GET_BANK_GUARANTEE.SUCCESS]: (data) => ({
    ...state,
    listBankGuarantee: { data: data.data, loading: false }
  }),
  [GET_BANK_GUARANTEE.FAILURE]: (data) => ({
    ...state,
    listBankGuarantee: { data: {}, loading: false }
  }),
  [GET_BANK_GUARANTEE_DETAIL.REQUEST]: () => ({
    ...state,
    bankGuarantee: { data: {}, loading: true }
  }),
  [GET_BANK_GUARANTEE_DETAIL.SUCCESS]: (data) => ({
    ...state,
    bankGuarantee: { data: data.data, loading: false }
  }),
  [GET_REF_BG_OPTIONS.REQUEST]: (data) => ({
    ...state,
    bgRefOptions: { data: [], loading: true }
  }),
  [GET_REF_BG_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    bgRefOptions: { data: data.data, loading: false }
  }),
  [GET_JOB.REQUEST]: () => ({
    ...state,
    jobs: { data: [], loading: true }
  }),
  [GET_JOB.SUCCESS]: (data) => ({
    ...state,
    jobs: { data: data.data, loading: false }
  }),
  [GET_BANK_OWNER.REQUEST]: () => ({
    ...state,
    bankOwners: { data: [], loading: true }
  }),
  [GET_BANK_OWNER.SUCCESS]: (data) => ({
    ...state,
    bankOwners: { data: data.data, loading: false }
  }),
  [GET_COMPANY_OPTIONS.REQUEST]: () => ({
    ...state,
    companyOptions: { data: [], loading: true }
  }),
  [GET_COMPANY_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    companyOptions: { data: data.data, loading: false }
  }),
  [GET_VENDOR_OPTIONS.REQUEST]: () => ({
    ...state,
    vendorOptions: { data: [], loading: true }
  }),
  [GET_VENDOR_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    vendorOptions: { data: data.data, loading: false }
  }),
  [GET_BG_WORKFLOW.REQUEST]: () => ({
    ...state,
    workflow: { data: [], loading: true }
  }),
  [GET_BG_WORKFLOW.SUCCESS]: (data) => ({
    ...state,
    workflow: { data: data.data, loading: false }
  }),
  [CLEAR_BG_FROM_DATA]: () => ({
    ...state,
    bankGuarantee: { data: {}, loading: false }
  }),
  [GET_FINANCE_USERS.REQUEST]: () => ({
    ...state,
    financeUser: { data: [], loading: true }
  }),
  [GET_FINANCE_USERS.SUCCESS]: (data) => ({
    ...state,
    financeUser: { data: data.data, loading: false }
  }),
  [EXPORT_BG_DATA.REQUEST]: () => ({
    ...state,
    bgExport: { data: [], loading: true }
  }),
  [EXPORT_BG_DATA.SUCCESS]: (data) => ({
    ...state,
    bgExport: { data: data.data, loading: false }
  }),
  [EXPORT_BG_DATA.FAILURE]: () => ({
    ...state,
    bgExport: { data: [], loading: false }
  }),
}))